import { render, staticRenderFns } from "./ToolDemoCover.vue?vue&type=template&id=7c323b4a&scoped=true"
import script from "./ToolDemoCover.vue?vue&type=script&lang=js"
export * from "./ToolDemoCover.vue?vue&type=script&lang=js"
import style0 from "./ToolDemoCover.vue?vue&type=style&index=0&id=7c323b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c323b4a",
  null
  
)

export default component.exports